import script from "./PointsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsOverview.vue?vue&type=script&setup=true&lang=js"

import "./PointsOverview.vue?vue&type=style&index=0&id=033b52cd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-033b52cd"]])

export default __exports__